import { DialogWithForm } from '@strata/react-dialog';
import { SuggestSingleSelectFormik } from '@strata/react-selects';
import { SuccessToast } from '@strata/react-toast-message';
import { validationStrings } from '@strata/strata-ui-strings';
import { Formik } from 'formik';
import PropTypes from 'prop-types';
import * as Yup from 'yup';

import { BulkChangeWarningMessage } from 'components/upcomingTreatments/dialogs/BulkChangeWarningMessage';
import { useAddToBatchMutation, useGetBatchesQuery } from 'store/api/goLiveApi';

const Title = 'Add to batch';

export const AddToBatchDialog = ({
    isOpen,
    onClose,
    treatmentsCount = 0,
    apiQueryParams = undefined,
}) => {
    const [addToBatch] = useAddToBatchMutation();

    const { data: batchOptions, isFetching: batchOptionsFetching } = useGetBatchesQuery();

    return (
        <Formik
            initialValues={{}}
            enableReinitialize
            validationSchema={Yup.object({
                batch: Yup.object().required(validationStrings.requiredField.errorMessage),
            })}
            onSubmit={async ({ batch }, { resetForm }) => {
                await addToBatch({ batch, ...apiQueryParams }).unwrap();
                SuccessToast({ message: 'Upcoming treatments successfully added to batch.' });
                resetForm();
                onClose();
            }}
        >
            {(formik) => (
                <DialogWithForm
                    dialogTitle={Title}
                    isOpen={isOpen}
                    width={440}
                    secondaryButtonLabel="Cancel"
                    onSecondaryButtonClick={() => {
                        formik.resetForm();
                        onClose();
                    }}
                    primaryButtonLabel={Title}
                    isPrimaryButtonDisabled={
                        !(formik.dirty && formik.isValid) || formik.isSubmitting
                    }
                    dialogContent={
                        <>
                            <SuggestSingleSelectFormik
                                id="batch"
                                label="Batch"
                                required
                                values={batchOptions ?? []}
                                isLoading={batchOptionsFetching}
                            />
                            <BulkChangeWarningMessage
                                apiQueryParams={apiQueryParams}
                                treatmentsCount={treatmentsCount}
                            />
                        </>
                    }
                />
            )}
        </Formik>
    );
};

AddToBatchDialog.Title = Title;

AddToBatchDialog.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    treatmentsCount: PropTypes.number,
    apiQueryParams: PropTypes.shape({
        treatmentId: PropTypes.string,
        searchText: PropTypes.string,
        goLiveDate: PropTypes.arrayOf(PropTypes.string),
        productServiceOid: PropTypes.arrayOf(PropTypes.string),
        segmentId: PropTypes.arrayOf(PropTypes.string),
        incumbentSupplier: PropTypes.arrayOf(PropTypes.string),
        productType: PropTypes.arrayOf(PropTypes.string),
        isLDD: PropTypes.arrayOf(PropTypes.bool),
        hasIssues: PropTypes.arrayOf(PropTypes.string),
        releaseStatus: PropTypes.arrayOf(PropTypes.string),
        upcomingTreatmentBatchName: PropTypes.arrayOf(PropTypes.string),
        preferredPharmacyOffer: PropTypes.arrayOf(PropTypes.string),
        therapeuticCategory: PropTypes.arrayOf(PropTypes.string),
    }),
};
